import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { APP_CONFIG, AppConfig } from "app/core";
import { Observable, throwError } from "rxjs";
import { AuthVerificationApiModel } from "./auth.apimodel";

/** Performs backend verification of an opaque loader-issued authentication session. */
@Injectable({ providedIn: "root" })
export class AuthApiClient {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(APP_CONFIG) private readonly appConfig: AppConfig
  ) {}

  /**
   * Verifies a loader-issued session and returns the authenticated user artifacts.
   * @param sessionId Opaque session identifier received from the loader.
   * @returns The backend verification response.
   */
  public verify(sessionId: string): Observable<AuthVerificationApiModel> {
    const verifyEndpoint = this.appConfig.auth?.verifyEndpoint;
    if (!verifyEndpoint) {
      return throwError(() => new Error("Authentication verification endpoint is not configured"));
    }

    const endpoint = new URL(verifyEndpoint, this.appConfig.backendBaseUrl).toString();
    const headers = new HttpHeaders({ "X-Arole-Auth-Session-Id": sessionId });
    return this.httpClient.get<AuthVerificationApiModel>(endpoint, { headers });
  }
}
